import * as React from 'react';

import { CellProps } from 'react-table';

import { Text } from '@components/common';

export const CreatedBy = <T extends AbstractTemplate>({ row }: CellProps<T>) => (
  <Text h='400'>{row.original.creator.name}</Text>
);
